import React, { useEffect, useState } from "react";
import { Label, RequiredRule } from 'devextreme-react/form';
import { CheckBox, DateBox, NumberBox, TextBox } from "devextreme-react";
import LVButtonAccion from "../../../Basicos/LVButtonAccion";
import { FormateoFechaPara_yyyyMMdd } from "neftis7_apicaller/src/funciones/Varios";

//PARTICIPANTE SIN AUTORIZACION
const EXT_Integrante = (props) => {

  const { ABM_EEX_Clientes: { function_ABM_EEX_Clientes_LeerPorDNISinPassword, function_ABM_EEX_Clientes_InsertarBasico } } = require('neftis7_apicaller');
  const [idCliente, setIdCliente] = useState(0);
  const [cuit, setCUIT] = useState("");
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [telefono, setTelefono] = useState("");
  const [eMail, setEMail] = useState("");
  const [fechaNacimiento, setFechaNacimiento] = useState(new Date());
  const [calle, setCalle] = useState("");
  const [numero, setNumero] = useState("");
  const [piso, setPiso] = useState("");
  const [depto, setDepto] = useState("");
  const [codigoPostal, setCodigoPostal] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [puedeGuardar, setPuedeGuardar] = useState(false);
  const [esMenor, setEsMenor] = useState(true);
  const linkTerminos = "https://neftis.com.ar/Terminos/" + props.CodigoCompania + "/Terminos.htm"
  const [cierreEnProceso, setCierreEnProceso] = useState(false);

  const handleIdClienteOnValueChanged = (e) => {
    setIdCliente(e.value)
  }

  const handleCuitOnValueChanged = (e) => {
    setCUIT(e.value)
  }

  const handleCuitonFocusOut = async (e) => {
    const resultClientes = await function_ABM_EEX_Clientes_LeerPorDNISinPassword(cuit)

    if (resultClientes && resultClientes.data && resultClientes.data.length > 0) {
      setIdCliente(resultClientes.data[0].IdCliente);
      setNombre(resultClientes.data[0].Nombre);
      setApellido(resultClientes.data[0].Apellido);
      setTelefono(resultClientes.data[0].Telefonos);
      setEMail(resultClientes.data[0].Emails);
      setFechaNacimiento(resultClientes.data[0].FechaNacimiento);

      setPuedeGuardar(false)
    }
    else {
      setIdCliente(0);
      setNombre("");
      setApellido("");
      setTelefono("");
      setEMail("");
      setFechaNacimiento(new Date());

      setPuedeGuardar(true)
    }
  }

  const handleNombreOnValueChanged = (e) => {
    setNombre(e.value)
  }

  const handleApellidoOnValueChanged = (e) => {
    setApellido(e.value)
  }

  const handleTelefonoOnValueChanged = (e) => {
    setTelefono(e.value)
  }

  const handleEMailOnValueChanged = (e) => {
    setEMail(e.value)
  }

  const handleFechaNacimientoOnValueChanged = (e) => {
    setFechaNacimiento(e.value)

    const fechaNacimiento = new Date(e.value);
    const hoy = new Date();
    let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
    const mes = hoy.getMonth() - fechaNacimiento.getMonth();
    const dia = hoy.getDate() - fechaNacimiento.getDate();

    if (mes < 0 || (mes === 0 && dia < 0)) {
      edad = edad - 1;
    }

    if (edad < 18) {
      setEsMenor(true)
      console.log('La fecha de nacimiento corresponde a un menor de 18 años.');
    }
    else {
      setEsMenor(false)
      console.log('La fecha de nacimiento corresponde a un MAYOR.');
    }
  }

  const handleCalleOnValueChanged = (e) => {
    setCalle(e.value)
  }

  const handleNumeroOnValueChanged = (e) => {
    setNumero(e.value)
  }

  const handlePisoOnValueChanged = (e) => {
    setPiso(e.value)
  }

  const handleDeptoOnValueChanged = (e) => {
    setDepto(e.value)
  }

  const handleCodigoPostalOnValueChanged = (e) => {
    setCodigoPostal(e.value)
  }

  const onClickGuardar = () => {

    if (!esMenor) {
      if (!termsAccepted) {
        alert("Debe aceptar los términos y condiciones.");
        return;
      }
    }

    if (!cuit || !nombre || !apellido) {
      alert("Todos los campos son obligatorios.");
      return;
    }

    if (!esMenor) {
      if (!telefono || !eMail) {
        alert("E-Mail y Teléfono son obligatorios para los adultos.");
        return;
      }
    }

    if (idCliente < 1) {
      const guardar = async () => {
        try {
          if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
          setCierreEnProceso(true);

          const IdCliente = await function_ABM_EEX_Clientes_InsertarBasico(apellido, nombre, cuit, await FormateoFechaPara_yyyyMMdd(fechaNacimiento), cuit, eMail, telefono)
        } catch (error) {
          alert(error);
        } finally {
          setCierreEnProceso(false); // Se habilita el botón de nuevo
        }
      }
      guardar();

      setCUIT("")
      setIdCliente(0);
      setNombre("");
      setApellido("");
      setTelefono("");
      setEMail("");
      setFechaNacimiento("");

      setPuedeGuardar(true)

      alert(nombre + ", te has registrado correctamente! Ahora continua cargando al resto de los integrantes.");
    }
    else {
      const modificar = async () => {
        try {
          //const IdCliente = await function_ABM_EEX_Clientes_InsertarBasico()
        } catch (error) {
          alert(error);
        }
      }
      modificar();
    }
  };

  useEffect(() => {
    localStorage.setItem("CodigoCompania", props.CodigoCompania);
    localStorage.setItem("CodigoEmpresa", props.CodigoEmpresa);
    localStorage.setItem("CodigoPlanta", props.CodigoPlanta);
  }, []);

  return (

    <table width={'100%'} >
      <tbody>

        <tr>
          <td style={{ margin: '10px', padding: '5px', textAlign: 'center', fontSize: '30px' }} colSpan={2}>
            REGISTRATE PARA UN INGRESO MÁS RÁPIDO!
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <NumberBox
              label="Código"
              value={idCliente}
              onValueChanged={handleIdClienteOnValueChanged}
              visible={false} />
          </td>
        </tr>

        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <NumberBox
              label="D.N.I."
              value={cuit}
              onValueChanged={handleCuitOnValueChanged}
              onFocusOut={handleCuitonFocusOut}>
              <Label text="D.N.I." />
              <RequiredRule message="Indicar el D.N.I. es obligatorio." />
            </NumberBox>
          </td>
        </tr>

        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <TextBox
              label="Nombre"
              value={nombre}
              onValueChanged={handleNombreOnValueChanged}>
              <Label text="Nombre" />
              <RequiredRule message="Indicar el Nombre es obligatorio." />
            </TextBox>
          </td>
        </tr>

        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <TextBox
              label="Apellido"
              value={apellido}
              onValueChanged={handleApellidoOnValueChanged}>
              <Label text="Apellido" />
              <RequiredRule message="Indicar el Apellido es obligatorio." />
            </TextBox>
          </td>
        </tr>

        <tr>
          <td width={150}>
            Fecha de Nacimiento
          </td>
          <td style={{ margin: '10px', padding: '5px' }}>
            <DateBox displayFormat="dd/MM/yyyy"
              value={fechaNacimiento}
              onValueChanged={handleFechaNacimientoOnValueChanged}
              width={120} >

            </DateBox>
          </td>
        </tr>

        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <TextBox
              label="Teléfono"
              value={telefono}
              visible={!esMenor}
              onValueChanged={handleTelefonoOnValueChanged}>
              <Label text="Teléfono" />
              <RequiredRule message="Indicar el Teléfono es obligatorio." />
            </TextBox>
          </td>
        </tr>

        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <TextBox
              label="E-Mail"
              value={eMail}
              visible={!esMenor}
              onValueChanged={handleEMailOnValueChanged}>
              <Label text="E-Mail" />
              <RequiredRule message="Indicar el E-Mail es obligatorio." />
            </TextBox>
          </td>
        </tr>



        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>

            <table width={'100%'} >
              <tbody>
                <tr>
                  <td style={{ margin: '10px', padding: '5px' }} colSpan={4}>
                    <TextBox
                      label="Calle"
                      value={calle}
                      onValueChanged={handleCalleOnValueChanged}
                      visible={false}>
                    </TextBox>
                  </td>
                </tr>

                <tr>
                  <td style={{ margin: '10px', padding: '5px' }}>
                    <NumberBox
                      label="Altura"
                      value={numero}
                      onValueChanged={handleNumeroOnValueChanged}
                      visible={false}>
                    </NumberBox>
                  </td>

                  <td style={{ margin: '10px', padding: '5px' }}>
                    <TextBox
                      label="Piso"
                      value={piso}
                      onValueChanged={handlePisoOnValueChanged}
                      visible={false}>
                    </TextBox>
                  </td>

                  <td style={{ margin: '10px', padding: '5px' }}>
                    <TextBox
                      label="Depto"
                      value={depto}
                      onValueChanged={handleDeptoOnValueChanged}
                      visible={false}>
                    </TextBox>
                  </td>

                  <td style={{ margin: '10px', padding: '5px' }}>
                    <TextBox
                      label="Código Postal"
                      value={codigoPostal}
                      onValueChanged={handleCodigoPostalOnValueChanged}
                      visible={false}>
                    </TextBox>
                  </td>
                </tr>
              </tbody>
            </table>

          </td>
        </tr>



        <tr>
          <td style={{ visibility: esMenor ? 'hidden' : 'visible', margin: '10px', padding: '5px' }} colSpan={2}>
            <div style={{
              background: '#f2b6b6',
              color: 'darkred',
              padding: '8px',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <CheckBox
                text="ACEPTO LOS TÉRMINOS y CONDICIONES"
                value={termsAccepted}
                visible={!esMenor}
                onValueChanged={(e) => setTermsAccepted(e.value)}
              />
            </div>
          </td>
        </tr>
        <tr style={{ height: '20px' }} >
        </tr>
        <tr>
          <td style={{ visibility: esMenor ? 'hidden' : 'visible', margin: '10px', padding: '5px' }} colSpan={2}>
            <a href={linkTerminos} target="_blank" rel="noopener noreferrer" style={{ display: esMenor ? 'none' : 'block' }}>
              TÉRMINOS y CONDICIONES
            </a>
            <div style={{ margin: '10px', padding: '5px' }}>
              <iframe
                src={linkTerminos}
                width="100%"
                height="500px"
                title="Términos y Condiciones"
              />
            </div>
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <LVButtonAccion
              Disabled={cierreEnProceso} Texto="GUARDAR" Ancho={'100%'} onClick={onClickGuardar} visible={puedeGuardar} />
          </td>
        </tr>
      </tbody>
    </table>
  );

}

export default EXT_Integrante;